import { render, staticRenderFns } from "./StraightenIcon.vue?vue&type=template&id=af5000bc&"
import script from "./StraightenIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StraightenIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports